import axios from 'axios'
import { getToken, clearAuth } from '@/utils/auth'
import { openLogin } from '@/utils/loginModal'

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api/portal' : '/api/portal',
  timeout: 15000
})

request.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

request.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code && res.code !== 200) {
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response && error.response.status
    if (status === 401) {
      clearAuth()
      const path = window.location.pathname + window.location.search
      if (!path.startsWith('/login/callback')) {
        openLogin(path)
      }
    }
    const msg = (error.response && error.response.data && error.response.data.msg) || error.message || '网络异常'
    return Promise.reject(new Error(msg))
  }
)

export default request
